import { IApp } from "@/types";
import AbstractSource from "./AbstractSource";

class BirdEyeSource extends AbstractSource {
  getDataTypes(): IApp.DataType[] {
    return [IApp.DataType.Default, IApp.DataType.BirdEyeReviews, IApp.DataType.BirdEyeListings];
  }
}

export default BirdEyeSource;
